import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

/**
 * Select component matching design system specifications
 */
export const Select = forwardRef(({ className, children, label, requiredIndicator, id, ...props }, ref) => {
  const selectId = id || `select-${props.name || Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <div className="w-full">
      {label && (
        <label 
          htmlFor={selectId}
          className="block text-meta font-medium text-gray-700 dark:text-gray-300 mb-1"
        >
          {label}
          {requiredIndicator && props.required && (
            <span className="text-[var(--ds-status-danger)] ml-1">*</span>
          )}
        </label>
      )}
      <select
        id={selectId}
        className={cn(
          'flex h-9 w-full',
          'bg-[var(--ds-control-field-bg)]',
          'border border-[var(--ds-control-field-border)]',
          'rounded-[var(--ds-radius-md)]',
          'px-3 py-2',
          'text-xs text-meta text-[var(--ds-text-primary)] dark:text-white',
          'focus:outline-none focus:ring-2 focus:ring-[var(--ds-accent-focus-ring)]',
          'focus:border-[var(--ds-accent-primary)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'transition-colors duration-180',
          'appearance-none bg-no-repeat bg-right',
          'pr-8',
          className
        )}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='none' stroke='%23999' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M3 4.5L6 7.5L9 4.5'/%3E%3C/svg%3E")`,
          backgroundPosition: 'right 0.75rem center',
          backgroundSize: '12px 12px',
        }}
        ref={ref}
        {...props}
      >
        {children}
      </select>
    </div>
  );
});

Select.displayName = 'Select';

